export default {
  props: {
    result: {
      type: Object,
      default: () => {
        calculation_data: []
      }
    }
  },
  data(){
    return {
      resultData: [],
      errors: [],
      errorState: false
    }
  },
  computed: {
    isFlightCalculation(){
      return  this.flightProposalId != null
    },
    flightProposalId(){
      if (this.result && this.result.calculation_data){
        return this.result.calculation_data[0].flight_proposal_id
      }
    }
  },
  watch: {
    result: {
      handler(val){
        if  (val && val.results && val.results.length > 0){
          this.resultData = val.results
          this.gTrack(`${this.currentStep}:loadedSuccess`)
          this.loaded = true
          this.errorState = false
        } else if (val && val.global && val.global.errors.length > 0){
          this.errors = val.global.errors
          this.gTrack(`${this.currentStep}:loadedError`)
          this.loaded = true
          this.errorState = true
        }else {
          this.gTrack(`${this.currentStep}:loadedFail`)
          this.resultData = []
          this.loaded = false
        }

        $('html, body').animate({
          scrollTop: $(this.$el).offset().top-200
        })
      }
    }
  },
  methods: {
    formatNumber(val){
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(val)
    }
  }

}